"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePaymentOptionEnum = void 0;
var InvoicePaymentOptionEnum;
(function (InvoicePaymentOptionEnum) {
    InvoicePaymentOptionEnum["BankTransfer"] = "BankTransfer";
    InvoicePaymentOptionEnum["CreditCard"] = "CreditCard";
})(InvoicePaymentOptionEnum = exports.InvoicePaymentOptionEnum || (exports.InvoicePaymentOptionEnum = {}));
